<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'eta',
};
</script>

<style>
</style>
